import { Injectable } from '@angular/core';
import { FullscreenViewAction } from './fullscreen-table.view-action';

@Injectable()
export class EnableFullscreenViewAction extends FullscreenViewAction {
  actionName: string = 'ENABLE_FULLSCREEN';

  onClick(context?: undefined): void {
    this.fullScreenService.setIsFullscreen(true);
  }
}
